export default __webpack_public_path__ + "static/media/users.3276d4f7.svg";